import axios from '@/service/request';
import apiConfig from '../apiConfig';

// 创建云信账号
export const createIM = () => axios.get(apiConfig.message_host_key + '/im/initial');

// 搜索用户
export const searchUser = (data) => axios.post(apiConfig.message_host_key + '/im/search',
  data
);

// 拉黑
export const blockUser = (data) => axios.post(apiConfig.message_host_key + '/im/block', data);

// 取消关注
export const unfollow = (data) => axios.post(apiConfig.message_host_key + '/im/unfollow', data);

// 删除好友
export const deleteFriend = (data) => axios.post(apiConfig.message_host_key + '/im/delFriend', data);

// 移除关注列表
export const deleteFollow = (data) => axios.post(apiConfig.message_host_key + '/im/delfollownotice', data);

// 设置新朋友已读提示
export const readFollowNotice = (data) => axios.post(apiConfig.message_host_key + '/im/readfollownotice', data);

// 设置别名
export const setAlias = (data) => axios.post(apiConfig.message_host_key + '/im/alias', data);

// 获取推荐用户
export const recommendUser = (data) => axios.post(apiConfig.message_host_key + '/im/recommendUser', data);

// 发送消息
export const sendMessage = (data) => axios.post(apiConfig.message_host_key + '/im/sendMessage', data);

// 获取聊天记录
export const getMessage = (data) => axios.post(apiConfig.message_host_key + '/im/getMessage', data);

// 获取互动消息列表
export const getCommentNotice = (data) => axios.get(apiConfig.message_host_key + '/im/getCommentNotice', { params: data });

// 标记互动消息已读
export const readCommentNotice = (data) => axios.post(apiConfig.message_host_key + '/im/readCommentNotice', data);

//  新版-私信列表
export const getPrivateMessage = params => axios.get('/member/getMessage', { params: params });

//  新版-私信消息发送
export const postSendPrivateMessage = params => axios.post('/member/addMessage', params);

//  获取用户收到的消息列表
export const getReceivedMessage = params => axios.get('/member/getMessageList', { params: params });
